import { atom } from "jotai";
import { ConnectionPhase, type ChatMessage } from "@/types/connection";
import { CaptureSource, EMPTY_METRICS, type StreamMetrics } from "@/types/stream";

export const connectionPhaseAtom = atom<ConnectionPhase>(ConnectionPhase.Idle);
export const metricsAtom = atom<StreamMetrics>({ ...EMPTY_METRICS });
export const activeSourcesAtom = atom<CaptureSource[]>([]);
export const chatMessagesAtom = atom<ChatMessage[]>([]);

/** Callback set by Home screen, invoked by titlebar stop button */
export const stopPublishCallbackAtom = atom<(() => void) | null>(null);
